// Endpoints de tempo — `/v1/metricas/tempo/*` (MET-01/02/03/06).
import { api } from '@/lib/api';
import type { Drilldown, MetricsDurationDto, MetricsOutsideHoursDto, WithEnvelope } from '../model';
import { metricsUrl, type MetricsListArgs, type MetricsSegmentArgs } from './shared';

export const metricsResponseApi = api.injectEndpoints({
  endpoints: (build) => ({
    /** MET-01 — tempo até a PRIMEIRA resposta humana. */
    metricsFirstResponse: build.query<WithEnvelope<MetricsDurationDto>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('tempo/primeira-resposta', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    /** MET-02 — intervalo entre respostas (por rajada do cliente, não por mensagem). */
    metricsResponseIntervals: build.query<WithEnvelope<MetricsDurationDto>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('tempo/intervalos', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    /** MET-02 — conversas que estouraram o intervalo. */
    metricsIntervalViolations: build.query<WithEnvelope<Drilldown>, MetricsListArgs>({
      query: (args) => metricsUrl('tempo/intervalos/violacoes', { ...args }),
      providesTags: ['MetricsDrilldown'],
    }),
    /** MET-03 — tempo total de resolução. */
    metricsResolution: build.query<WithEnvelope<MetricsDurationDto>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('tempo/resolucao', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
    /** MET-06 — volume fora do horário comercial. */
    metricsOutsideHours: build.query<WithEnvelope<MetricsOutsideHoursDto>, MetricsSegmentArgs>({
      query: (args) => metricsUrl('tempo/fora-horario', { ...args }),
      providesTags: ['MetricsAggregate'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useMetricsFirstResponseQuery,
  useMetricsResponseIntervalsQuery,
  useMetricsIntervalViolationsQuery,
  useMetricsResolutionQuery,
  useMetricsOutsideHoursQuery,
} = metricsResponseApi;
